




// CSS
import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import  '../styles/style.scss';





// JS
import "bootstrap/dist/js/bootstrap.min";

// ui Plugins

// import 'lazysizes';





// other Functions
import {menuMobile} from './js-components/menuMobile.js';
import {submenuHoverOpenV2} from './js-components/submenuHoverOpenV2.js';
import {inputMaterialDesign} from './js-components/inputMaterialDesign.js';
import {bootstrapCollapse} from './js-components/bootstrapCollapse.js';
import {bootstrapModal} from './js-components/bootstrapModal.js';



jQuery( document ).ready(function() {

    menuMobile();
    submenuHoverOpenV2();
    inputMaterialDesign();
    bootstrapCollapse();
    bootstrapModal();


    inputMaterialDesign
});
